// eslint-disable-next-line import/no-webpack-loader-syntax
import workerUrl from 'worker-plugin/loader!./mergeSets'

export default workerUrl